import React, {useEffect, useState} from 'react';
import {Row, Col, Form, Button, InputGroup} from "react-bootstrap";
import ProductItem from "./ProductItem";

const ProductList = ({
    products,
    page,
    setPage,
    totalCount,
    limit,
    setShowFilters,
    search,
    setSearch,
    sortBy,
    sortOrder,
    onSortChange,
    onSearchSubmit,
    isSearching = false,
    isLoading = false,
    activeFilters = {},
    hasActiveFilters = false,
    onResetFilters
}) => {
    console.log('ProductList debug:', { productsLength: products.length, totalCount, page, limit });

    const [localSearch, setLocalSearch] = useState(search || '');

    useEffect(() => {
        setLocalSearch(search || '');
    }, [search]);

    const handleSearchClick = () => {
        const value = (localSearch || '').trim();
        if (onSearchSubmit) {
            onSearchSubmit(value);
        } else if (setSearch) {
            setSearch(value);
        }
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearchClick();
        }
    };

    const handleClearSearch = () => {
        setLocalSearch('');
        if (onSearchSubmit) {
            onSearchSubmit('');
        } else if (setSearch) {
            setSearch('');
        }
    };

    return (
        <div className="product-list shop-container-fluid">
            <Row className="mb-3 product-list-search-row g-2 align-items-center">
                <Col xs={12} md={5}>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            placeholder="Поиск по названию или артикулу..."
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={handleSearchKeyDown}
                        />
                        {localSearch && (
                            <Button
                                variant="outline-secondary"
                                onClick={handleClearSearch}
                                aria-label="Очистить поиск"
                            >
                                ✕
                            </Button>
                        )}
                        <Button
                            variant="primary"
                            onClick={handleSearchClick}
                            aria-label="Найти товары"
                        >
                            Найти
                        </Button>
                    </InputGroup>
                </Col>
                <Col xs={7} md={4}>
                    <Form.Select 
                        value={`${sortBy}-${sortOrder}`}
                        onChange={e => {
                            const [newSortBy, newSortOrder] = e.target.value.split('-');
                            onSortChange(newSortBy, newSortOrder);
                        }}
                    >
                        <option value="price-asc">Цена (по возрастанию)</option>
                        <option value="price-desc">Цена (по убыванию)</option>
                        <option value="quantity-asc">Остаток (по возрастанию)</option>
                        <option value="quantity-desc">Остаток (по убыванию)</option>
                        <option value="rating-asc">Рейтинг (по возрастанию)</option>
                        <option value="rating-desc">Рейтинг (по убыванию)</option>
                        <option value="createdAt-desc">Новинки</option>
                    </Form.Select>
                </Col>
                <Col xs={5} md={3}>
                    <Button variant="primary" className="w-100" onClick={() => setShowFilters(true)}>
                        Фильтры
                    </Button>
                </Col>
            </Row>
            {(hasActiveFilters || search) && (
                <Row className="mb-3">
                    <Col xs={12}>
                        <div className="product-list-active-bar d-flex flex-wrap align-items-center gap-2">
                            {search && (
                                <span>
                                    Поиск по запросу: <strong>"{search}"</strong>
                                    {isSearching && <span className="ms-2">Идёт поиск…</span>}
                                </span>
                            )}
                            {hasActiveFilters && (
                                <span>
                                    Фильтры:
                                    {activeFilters.category && (
                                        <span className="ms-1 badge bg-light text-dark">
                                            Категория: {activeFilters.category.name}
                                        </span>
                                    )}
                                    {activeFilters.store && (
                                        <span className="ms-1 badge bg-light text-dark">
                                            Магазин: {activeFilters.store.name}
                                        </span>
                                    )}
                                    {Array.isArray(activeFilters.sizes) && activeFilters.sizes.length > 0 && (
                                        <span className="ms-1 badge bg-light text-dark">
                                            Размеры: {activeFilters.sizes.join(', ')}
                                        </span>
                                    )}
                                </span>
                            )}
                            {(hasActiveFilters || search) && onResetFilters && (
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 ms-auto ms-md-3 text-decoration-none"
                                    onClick={onResetFilters}
                                >
                                    Сбросить фильтры и поиск
                                </Button>
                            )}
                        </div>
                    </Col>
                </Row>
            )}
            {isLoading ? (
                <div className="product-list-empty-state mt-3">
                    <h4>Загружаем товары…</h4>
                    <p>Пожалуйста, подождите, мы подбираем подходящие товары по выбранным параметрам.</p>
                </div>
            ) : (
                <>
                    {products.length === 0 ? (
                        <div className="product-list-empty-state mt-3">
                            <h4>Товары не найдены</h4>
                            {search ? (
                                <p>По запросу <strong>"{search}"</strong> ничего не найдено.</p>
                            ) : (
                                <p>По текущим фильтрам товары не найдены.</p>
                            )}
                            <ul>
                                <li>Попробуйте изменить запрос или удалить часть слов.</li>
                                <li>Сбросьте фильтры или выберите другие параметры.</li>
                                <li>Убедитесь, что выбран правильный раздел каталога.</li>
                            </ul>
                        </div>
                    ) : (
                        <Row className="g-3 g-md-4 mt-1">
                            {products.map(product =>
                                <Col xs={6} md={4} lg={3} key={product.id} className="d-flex">
                                    <ProductItem product={product}/>
                                </Col>
                            )}
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

export default ProductList;